import React from 'react';
import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

import { i18n } from '../../widgetMacroI18n.ts';
import type { EmbedDescriptor } from '../../widgetMacroTypes.ts';

const styles = cssMap({
	root: {
		border: 'none',
		marginBlockStart: token('space.150'),
		marginBlockEnd: token('space.150'),
	},
});

type Props = {
	descriptor: EmbedDescriptor;
};

/**
 * Renders a plain iframe for providers that do not require fullscreen support.
 */
export const IframeEmbed = ({ descriptor }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const title = formatMessage(i18n.embedTitle, { provider: descriptor.provider });

	return (
		<Box xcss={styles.root} testId="widget-macro-iframe">
			<iframe
				title={title}
				src={descriptor.embedUrl}
				width={descriptor.width || undefined}
				height={descriptor.height || undefined}
				frameBorder={0}
				allowTransparency
			/>
		</Box>
	);
};
